var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cloud-bed"},[_c('div',{staticClass:"cloud-boxs"},_vm._l((_vm.personList),function(item,index){return _c('span',{key:index,style:({color:_vm.placeList[index].color,background:_vm.placeList[index].bgColor}),on:{"click":function($event){return _vm.getDataInfo(item)}}},[_vm._v(" "+_vm._s(item.referValue)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }